// 应用商场
export default [
  {
    path: "/appStore",
    name: "appStore",
    component: () => import("@/views/appStore/appStore.vue"),
    meta: {
      title: "行业方案模板",
    },
  },
];
